import axiosInstance from "@/api/axiosInstance";
import { CreateProductOrderRequest, CreateProductOrderApiResponse } from "./types";

export const createProductOrder = async (
  data: CreateProductOrderRequest,
): Promise<CreateProductOrderApiResponse> => {
  const response = await axiosInstance.post<CreateProductOrderApiResponse>(
    "/api/private/product-order/create",
    data,
  );
  return response.data;
};
